import fetch from '../utils/fetch';

// 获取筛选条件
export function getInitData() {
    return fetch({
        method: 'GET',
        url: 'basics/projects',
    })
}

// 列表查询
export function getList(params) {
    return fetch({
        method:'GET',
        url:'waterwatt/standard/list',
        params
    })
}

// 费用标准设置-初始数据
export function setData() {
    return fetch({
        method: 'GET',
        url: 'waterwatt/settings/condition',
    })
}

// 水电-费用标准设置-查询
export function settingsGet(params) {
    return fetch({
        method: 'GET',
        url: 'waterwatt/settings/get',
        params
    })
}

// 水电-费用标准设置-保存
export function settingsSave(data) {
    return fetch({
        method: 'POST',
        url: 'waterwatt/settings/save',
        data
    })
}

export function getMeterTypeList(params) {
  return fetch({
    method: 'GET',
    url: '/waterwatt/getMeterTypeList',
    params
  })
}

export function waterwattordinaryhaveRead(params) {
  return fetch({
    method: 'GET',
    url: '/waterwatt/ordinary/haveRead',
    params
  })
}
